import { createSlide } from "../../slidesOps/createSlide";
import LogoSVG from "../../../../icons/logo.svg";
import "./index.scss";
export function slideWelcome(msg, length = 15000) {
    const html = `
        <div class="fragment fade-down" data-autoslide="1000">${LogoSVG}</div>
        ${msg
        ? '<p class="fragment fade-left" data-autoslide="500">' +
            msg +
            "</p>"
        : ""}
        <div class="fragment" data-autoslide="${length}"></div>
    `;
    return () => {
        createSlide({
            autoslide: 200,
            center: true,
            html: html,
            classList: "video-bg",
            placement: "prepend", // make sure it's first
            wrap: "false",
            background: {
                color: null,
                video: "https://www.cedarparkchurchofchrist.org/media/uploads/src/board/bg-trees.mp4",
                "video-loop": true,
                "video-muted": true,
                size: "cover",
            },
        }, "welcome");
    };
}
